export default {
  app: { name: 'ProofFleet', offline: 'Offline', queued: 'Queued: {{count}}' },
  login: {
    title: 'Driver sign-in',
    phone: 'Phone',
    pin: 'PIN',
    submit: 'Sign in',
    error: 'Wrong phone or PIN',
    deviceBlocked: 'Device not registered. Contact your manager.',
    language: 'Language',
  },
  policy: {
    title: 'Inspection policy',
    version: 'Revision {{version}}',
    accept: 'I have read and accept',
    accepting: 'Submitting…',
    required: 'Read the fleet policy to continue.',
    changed: 'The policy changed. Please read the current revision.',
  },
  unit: {
    title: 'Select a vehicle',
    scan: 'Scan the door QR code',
    manual: 'Pick from list',
    search: 'Unit number',
    empty: 'No vehicles found',
    notRecognized: 'Sticker not recognized',
  },
  briefing: {
    title: 'Open defects',
    subtitle: 'Reported on this vehicle earlier. Confirm you have seen them.',
    none: 'No open defects',
    acknowledge: 'I have seen these',
    reported: 'Reported {{date}}',
  },
  inspection: {
    title: 'Inspection',
    progress: '{{done}} of {{total}}',
    ok: 'Good',
    defect: 'Defect',
    skip: 'Not applicable',
    photo: 'Take photo',
    photoRequired: 'Photo required',
    retake: 'Retake',
    note: 'Note',
    value: 'Reading',
    enterValue: 'Enter reading',
    limit: 'Limit: {{value}}{{unit}}',
    verdictOk: 'Within limits',
    verdictWarn: 'Below limits',
    verdictCritical: 'Critical',
    next: 'Next',
    back: 'Back',
    finish: 'Finish inspection',
    incomplete: 'Some items are not filled in',
    submitting: 'Submitting…',
  },
  done: {
    title: 'Inspection submitted',
    queued: 'Saved. It will be sent when you are back online',
    verdictPass: 'No findings',
    verdictDefects: 'Findings recorded',
    verdictCritical: 'Critical defect found',
    notified: 'The responsible person has been notified',
    again: 'Inspect another vehicle',
  },
  common: {
    retry: 'Retry',
    cancel: 'Cancel',
    close: 'Close',
    loading: 'Loading…',
    error: 'Something went wrong',
    logout: 'Sign out',
  },
  push: {
    ask: "Want an alert when a defect on your truck needs attention?",
    enable: "Turn on notifications",
    install:
      'To receive alerts on iPhone, add this app to your Home Screen: tap Share, then “Add to Home Screen”.',
    done: "Notifications are on.",
  },
  voice: {
    record: "Record a voice note",
    stop: "Stop",
    rerecord: "Record again",
    denied: "Microphone access was denied",
  },
  history: {
    title: "My inspections",
    openDefects: "Open defects on my units",
    inspections: "Submitted",
    empty: "Nothing submitted yet",
    clean: "Clean",
    findings: "{{count}} finding(s)",
    critical: "{{count}} critical",
    back: "Back to vehicles",
    link: "History",
  },
} as const;
